<nav class="navbar">
    <div class="navbar-content">
        <p class="navbar-text text-danger warning-text">
            <i class="feather icon-alert-triangle"></i> Empresa Suspensa, contacte a Geolink se necessário
        </p>
    </div>
</nav>
